<template>
    <div class="order-1">
        <Slide :closeOnNavigation="false" class="mobile-main-menu" :isOpen="is_open" :burgerIcon="false" :crossIcon="false" disableOutsideClick left>
            <div class="d-block w-100 text-right py-1"><a href="#" @click="close" class="d-flex mobile-close mb-2 border-0 justify-content-end align-items-center">
                <div style="display:inline;font-weight:normal;color:#4e4e4e;">EXIT</div>
                <i class="fa-2x fal fa-times ml-2 mr-0"></i>
            </a></div>
            <div id="shop-mobile-nav-container">
                
                <div class="main-nav-group w-100">
            <a class="nav-link pointer py-1 justify-content-between" @click="openNav('shop')">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-shopping-bag mr-3"></i></div>SHOP</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i></span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="/subscription-box">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-archive mr-3"></i></div>SUBSCRIPTION BOX</span>
            </a>
            <div class="hr"><hr class="long-light"></div>
             <a class="nav-link pointer py-1 justify-content-between" @click="openNav('crystals')">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-book mr-3"></i></div>CRYSTAL DATABASE</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i></span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="/gift-card">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-credit-card mr-3"></i></div>GIFT CARDS</span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="/gift-box">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-gift mr-3"></i></div>GIFT BOX</span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="/blog">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-bookmark mr-3"></i></div>BLOG</span>
            </a>
            <div class="hr"><hr class="long-light"></div>
             <a class="nav-link pointer py-1 justify-content-between" @click="openNav('about')">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-user-friends mr-3"></i></div>ABOUT</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i></span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="/nft">
                <span class="align-items-center"><div class="nav-icon mr-3"><i class="fal fa-ticket-alt mr-3"></i></div>LIFETIME DISCOUNT</span>
            </a>
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="#" @click="login">
                <span class="align-items-center" v-if="!username"><div class="nav-icon mr-3"><i class="fal fa-user-circle mr-3"></i></div>LOGIN | REGISTER</span>
                <span class="align-items-center" v-if="username"><div class="nav-icon mr-3"><i class="fal fa-user-circle mr-3"></i></div>ACCOUNT</span>
            </a>
        </div>
            <!--
            <a class="nav-link py-1" v-for="menu_item in menu_items" :href="menu_item.value">
                <span v-if="menu_item.parameters"><i :class="menu_item.parameters.icon_classes"></i></span>{{ menu_item.name }}
            </a>
        -->
            <div class="nested-nav justify-content-center" id="crystals-mobile-nav">
                <a class="nav-link py-1" href="#" @click="closeNav('crystals')"><span class="align-items-center"><i class="fas fa-caret-left fa-1x mr-3"></i><i class="fal fa-book mr-3"></i>CRYSTAL DATABASE</span></a>
                <div class="hr"><hr class="long-light"></div>
                <div class="row nav-link m-0 pt-0">
            <div class="col-12 mb-3">
              <b>Looking to Explore Crystal Meanings?</b>
              <a class="btn btn-lg btn-primary text-white text-center w-100 mt-2" href="/crystals">Browse All Crystals</a>
            </div>
            <div class="col-6">
              <a href="/crystals">
                <img src="/images/book.svg"/>
                <span>Crystals<br/>A to Z</span>
              </a>
            </div>
            <div class="col-6">
              <a href="/tags/properties">
                <img src="/images/all-properties-icon.svg"/>
                <span>Search By<br/>EMOTIONS</span>
              </a>
            </div>
            <div class="col-6">
              <a href="/tags/zodiacs">
              <img src="/images/all-zodiacs-icon.svg"/>
              <span>Search By<br/>ZODIAC</span>
                </a>
            </div>
            <div class="col-6">
              <a href="/tags/planets">
              <img src="/images/all-planets-icon.svg"/>
              <span>Search By<br/>PLANET</span>
            </a>
            </div>
            <div class="col-6">
              <a href="/tags/elements">
              <img src="/images/all-elements-icon.svg"/>
              <span>Search By<br/>ELEMENT</span>
            </a>
            </div>
            <div class="col-6">
              <a href="/tags/chakras">
              <img src="/images/all-chakras-icon.svg"/>
              <span>Search By<br/>CHAKRA</span>
            </a>
            </div>
          </div>
            </div>

            <div class="nested-nav" id="shop-mobile-nav">
                <a class="nav-link py-1" href="#" @click="closeNav('shop')"><span class="align-items-center"><i class="fas fa-caret-left fa-1x mr-3"></i><i class="fal fa-shopping-bag mr-3"></i>SHOP</span></a>
                <div class="hr"><hr class="long-light"></div>
                <div class="nav-link"><a class="btn btn-lg btn-primary text-white text-center w-100" href="/shop">Browse Our Shop</a></div>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1 justify-content-between" href="#" @click="toggleExpand('featured')" id="featured-mobile-nav-toggle">
                    <span class="align-items-center">FEATURED PRODUCTS</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i>
                        <i class="fas fa-caret-down fa-1x"></i></span>
                </a>
                <div class="nested-sub-nav" id="featured-mobile-nav">
                    <a class="nav-link py-1" href="/shop/all">Shop All Products</a>
                    <a class="nav-link py-1" href="/shop/all?sort=popular&low=0&high=0&category=show-all">Best Sellers</a>
                    <a class="nav-link py-1" href="/shop/all?sort=recent&low=0&high=0&category=show-all">New Arrivals</a>
                    <a class="nav-link py-1" href="/shop/categories/rare-finds">Rare Finds</a>
                    <a class="nav-link py-1" href="/shop/categories/on-sale">On Sale</a>
                    <a class="nav-link py-1" href="/shop/categories/under-50">Products Under $50</a>
                </div>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1 justify-content-between" href="#" @click="toggleExpand('crystal-products')" id="crystal-products-mobile-nav-toggle">
                    <span class="align-items-center">CRYSTAL PRODUCTS</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i>
                        <i class="fas fa-caret-down fa-1x"></i></span>
                </a>
                <div class="nested-sub-nav" id="crystal-products-mobile-nav">
                    <a class="nav-link py-1" href="/shop/categories/raw-crystals">Raw Crystals</a>
                    <a class="nav-link py-1" href="/shop/categories/pocket-stones">Tumbled Stones</a>
                    <a class="nav-link py-1" href="/shop/categories/palmstones">Palmstones</a>
                    <a class="nav-link py-1" href="/shop/categories/shapes">Crystal Shapes</a>
                    <a class="nav-link py-1" href="/shop/categories/animals">Animals Carvings</a>
                    <a class="nav-link py-1" href="/shop/categories/bracelets">Bracelets</a>
                    <a class="nav-link py-1" href="/shop/categories/necklaces">Necklaces</a>
                    <a class="nav-link py-1" href="/subscription-box">Crystal Subscription Box</a>
                </div>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1 justify-content-between" href="#" @click="toggleExpand('meditation')" id="meditation-mobile-nav-toggle">
                    <span class="align-items-center">MEDITATION &amp; MORE</span><span class="caret-icon"><i class="fas fa-caret-right fa-1x"></i>
                        <i class="fas fa-caret-down fa-1x"></i></span>
                </a>
                <div class="nested-sub-nav" id="meditation-mobile-nav">
                    <a class="nav-link py-1" href="/shop/categories/meditation-tools">Meditation Tools</a>
                    <a class="nav-link py-1" href="/shop/categories/displays-stands">Displays &amp; Stands</a>
                    <a class="nav-link py-1" href="/tags/properties/">Shop By Intention or Mood</a>
                    <a class="nav-link py-1" href="/tags/zodiacs">Shop By Zodiac Sign</a>
                    <a class="nav-link py-1" href="/crystals">Shop By Other Types</a>
                </div>
                <div class="d-block mt-3 mb-5 w-100 text-center"><a href="/subscription-box"><img data-src="/images/mobile-box-cta-promo.webp" class="img-promo lazy" /></a></div>
            </div>

            <div class="nested-nav" id="about-mobile-nav">
                <a class="nav-link py-1" href="#" @click="closeNav('about')"><span class="align-items-center"><i class="fas fa-caret-left fa-1x mr-3"></i><i class="fal fa-shopping-bag mr-3"></i>ABOUT</span></a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/about">Our Story</a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/authenticity">Authenticity</a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/contact">Contact Us</a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="/help">FAQ's</a>
                <div class="hr"><hr class="long-light"></div>
                <a class="nav-link py-1" href="https://wholesale.thecrystalcouncil.com" target="_blank">Wholesale</a>
            </div>
            
            <div class="hr"><hr class="long-light"></div>
            <a class="nav-link py-1 justify-content-start" href="#">
                <currency-settings class="nav-link" :ui_style="'dark'" :prev_currency="prev_currency"></currency-settings>
            </a>
            
            </div>

            <ul class="list-unstyled px-2 px-xl-3 mobile-nav-footer">
                <li class="nav-item px-4 px-lg-2 px-xl-3 mt-2 social">
                 <a href="https://twitter.com/_crystalcouncil" class="border-0" target="_blank"><i class="fab fa-1x mr-3 fa-twitter"></i></a>
                 <a href="https://instagram.com/the_crystal_council" class="border-0" target="_blank"><i class="fab fa-1x mr-3 fa-instagram"></i></a>
                 <a href="https://facebook.com/thecrystalcouncil" class="border-0" target="_blank"><i class="fab fa-1x mr-3 fa-facebook"></i></a>
                </li>
            </ul>
        </Slide>
        <a class="hamburger-link nav-link px-3 py-0 d-xs-inline d-xl-none order-1" href="#" @click="open" aria-label="Open Main Menu">
            <i class="mobile-nav-icon mobile-burger fal fa-bars"></i>
        </a>
        <a class="hidden-search" id="hidden-search" href="#" @click="openSearch"></a>
        
    </div>
</template>

<script>
import { Slide } from 'vue-burger-menu'

export default {
    components: {
        Slide
    },
    props: {
        menu_items: Array,
        username: null,
        prev_currency: {
          type: String,
          default: 'USD'
        },
    },
    data() {
        return  {
            is_open: false,
            token: window.Laravel.csrfToken,
            
        }
    },
    mounted:function(){
    },
    methods: {
        openSearch(e) {
            console.log("OPEN SEAR")
            e.stopPropagation();
            $("body").addClass("disable-scroll");
            
            this.is_open = true;
            setTimeout(function() { $("#shop-mobile-nav-container .ais-SearchBox-input").focus(); }, 100);

        },
        open(e) {
            console.log("TRYING TO OPEN");
            e.stopPropagation();
            $("body").addClass("disable-scroll");

            this.is_open = true;
            console.log(this.is_open);
        },
        close(e) {
            e.stopPropagation();
            $("body").removeClass("disable-scroll")
            this.is_open = false;
        },
        login(e) {
            e.stopPropagation();
            $("body").removeClass("disable-scroll")
            this.is_open = false;
            
            setTimeout(function() { document.getElementById('mobile-user-icon').click(); }, 100);
        },
        openNav(e) {
            $("#" + e + "-mobile-nav").addClass('open');
            $("#shop-mobile-nav-container").addClass('open');
        },
        closeNav(e) {
            $("#" + e + "-mobile-nav").removeClass('open');
            $("#shop-mobile-nav-container").removeClass('open');
        },
        toggleExpand(e) {
            const navs = Array.from(document.getElementsByClassName('expand'));
            navs.forEach(nav => {
                if($(nav).attr('id') !== e + "-mobile-nav" && $(nav).attr('id') !== e + "-mobile-nav-toggle")
                {
                    $(nav).removeClass('expand');
                }
            });
            $("#" + e + "-mobile-nav").toggleClass('expand');
            $("#" + e + "-mobile-nav-toggle").toggleClass('expand');
        }
    },
    http: {
        root: '/root',
        headers: {
            'X-CSRF-Token': Laravel.csrfToken
        }
    }
    
};
</script>
